/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Request_CooldownInputs */



/**
* | output |
* | --- |
* | "This request was already sent. You can resend in about an hour." |
*
* @param {Project_Access_Request_CooldownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_request_cooldown = /** @type {((inputs?: Project_Access_Request_CooldownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Request_CooldownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Anfrage wurde bereits gesendet. Sie können in etwa einer Stunde erneut senden.")
	return /** @type {LocalizedString} */ ("This request was already sent. You can resend in about an hour.")
});